import { ServerPageData } from '@/features/product-editor/types';
import { mainApi } from '@/lib/api';
import type { PageOrderItem } from '../types/store';

export async function updatePagesOrder(storeId: number, pages: PageOrderItem[]): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/pages/order`, pages);
}

export async function updatePage(storeId: number, page: ServerPageData): Promise<void> {
    await mainApi.put(`v1/stores/${storeId}/pages`, page);
}
